import PhotoSwipeLightbox from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe-lightbox.esm.min.js';

if (!customElements.get('gallery-slider')) {
  class GallerySlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 0,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        autoplay: {
          enabled: this.dataset.autoplay === 'true',
          delay: parseInt(this.dataset.autoplaySpeed) || 5000,
        },
        breakpoints: {
          990: {
            slidesPerView: 2,
          }
        }
      });

      const lightbox = new PhotoSwipeLightbox({
        gallery: `#${this.getAttribute('id')}`,
        children: '.gallery-slider__item',
        bgOpacity: 0.8,
        showHideAnimationType: 'none',
        pswpModule: () => import('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js')
      });
      lightbox.init();

      lightbox.on('afterInit', () => {
        this.slider.autoplay.stop();
      });

      lightbox.on('close', () => {
        this.slider.autoplay.start();
      });
    }
  }
  customElements.define('gallery-slider', GallerySlider);
}
